var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrstateIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1766 16.875L30.0238 20.6679V32.5077L43.9773 35.714C42.3304 38.7917 43.1481 42.609 45.8701 44.7562V53.2813H51.5422L49.9435 55.9194H7.66406V53.2813H14.1766V16.875ZM55.6012 45.532V54.2266L57.9819 55.9206H50.3097L52.6887 54.2275V44.7031C48.7408 46.3589 44.2745 43.4756 44.2745 39.1075C44.2745 36.5297 45.8821 34.3274 48.1497 33.4487C48.5973 30.5398 51.1113 28.3134 54.1456 28.3134C57.4812 28.3134 60.1861 31.0042 60.2121 34.3333C62.6116 35.1421 64.3397 37.4119 64.3397 40.0833C64.3397 44.6086 59.5753 47.485 55.6016 45.5319L55.6012 45.532ZM17.8722 23.8899H20.982V27.0744H17.8722V23.8899ZM23.2204 23.8899H26.3294V27.0744H23.2204V23.8899ZM17.8722 29.3875H20.982V32.5728H17.8722V29.3875ZM23.2204 29.3875H26.3294V32.5728H23.2204V29.3875ZM17.8722 34.8851H20.982V38.0696H17.8722V34.8851ZM23.2204 34.8851H26.3294V38.0696H23.2204V34.8851ZM19.3202 44.4713H24.8813V52.2574H19.3202V44.4713ZM33.7192 39.1364H36.829V42.3209H33.7192V39.1364ZM39.0674 39.1364H42.1771V42.3209H39.0674V39.1364ZM33.7192 45.1033H36.829V48.2879H33.7192V45.1033ZM39.0674 45.1033H42.1771V48.2879H39.0674V45.1033Z",
    fill: "url(#paint0_linear_8677_44486)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8677_44486",
    x1: 36.0019,
    y1: 9.06588,
    x2: 36.0019,
    y2: 55.9206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#397786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153D46"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrstateIcon);
export default __webpack_public_path__ + "static/media/prstate_icon.13cccbab026b0811017442cb09baea67.svg";
export { ForwardRef as ReactComponent };